import { render, staticRenderFns } from "./orgList.vue?vue&type=template&id=923bc356&scoped=true"
import script from "./orgList.vue?vue&type=script&lang=ts"
export * from "./orgList.vue?vue&type=script&lang=ts"
import style0 from "./orgList.vue?vue&type=style&index=0&id=923bc356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bc356",
  null
  
)

export default component.exports